import { render, staticRenderFns } from "./EditComponentView.vue?vue&type=template&id=459859b0&scoped=true"
import script from "./EditComponentView.vue?vue&type=script&lang=js"
export * from "./EditComponentView.vue?vue&type=script&lang=js"
import style0 from "./EditComponentView.vue?vue&type=style&index=0&id=459859b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459859b0",
  null
  
)

export default component.exports